import Vue  from 'vue'
import Vuex from 'vuex'
import {
    A_LOGOUT,
    A_START_TASK,
    G_BUTTON_PROGRESS,
    G_USERNAME,
    M_BUTTON_PROGRESS,
    M_LOGIN, M_LOGOUT,
    M_SET_CONTRACT_INVOICES_VIEW,
    M_UPDATE_BIGFOX_NETWORK_VIEW,
    M_UPDATE_BIGFOX_PRINTER_VIEW,
    M_UPDATE_CONTRACTS_VIEW,
    M_UPDATE_INVOICES_VIEW,
    M_UPDATE_NOW,
    M_UPDATE_PRINTERS_VIEW,
    M_SET_TITLE,
    M_SET_SUBTITLE
} from '@/lib/constants';

Vue.use(Vuex);

const contractsView =
    {
        orderBy: 'START_DESC',
        tableSortBy: 'start',
        tableSortDesc: true
    }

const printersView = { };
const invoicesView = {
    orderBy: 'CREATED_DESC',
    tableSortBy: 'created',
    tableSortDesc: true
};

const contractInvoicesView =
    {
        orderBy: 'CREATED_DESC',
        tableSortBy: 'created',
        tableSortDesc: true
    };

function set(name)
{
    return function(state, payload) { state[name] = payload }
}

export default new Vuex.Store(
    {
        state:
        {
            bigfoxNetworkView: {},
            bigfoxPrinterView: {},
            buttonProgress: {},
            perPage: 15,
            contractsView,
            resetContractsView: contractsView,
            printersView,
            resetPrintersView: printersView,
            subTitle: '',
            invoicesView,
            loggedIn: false,
            resetInvoicesView: invoicesView,
            contractInvoicesView,
            resetContractInvoicesView: contractInvoicesView,
            title: '',
            now: Date.now(),
            updateNowInterval: 0,
            username: ''
        },
        mutations:
        {
            [M_UPDATE_CONTRACTS_VIEW]: set('contractsView'),
            [M_UPDATE_PRINTERS_VIEW]: set('printersView'),
            [M_UPDATE_BIGFOX_NETWORK_VIEW]: set('bigfoxNetworkView'),
            [M_UPDATE_BIGFOX_PRINTER_VIEW]: set('bigfoxPrinterView'),
            [M_UPDATE_INVOICES_VIEW]: set('invoicesView'),
            [M_SET_CONTRACT_INVOICES_VIEW]: set('contractInvoicesView'),
            [M_SET_TITLE]: set('title'),
            [M_SET_SUBTITLE]: set('subTitle'),
            [M_UPDATE_NOW]: state => state.now = Date.now(),
            [M_LOGIN]: (state, {username}) =>
            {
                state.loggedIn = true;
                state.username = username
            },
            [M_LOGOUT]: state => state.loggedIn = false,
            [M_BUTTON_PROGRESS]: (state, {buttonId, percent}) => Vue.set(state.buttonProgress, buttonId, percent)
        },
        actions:
        {
            /**
             *
             * @param ctx
             * @param {Object} payload
             * @param {Object} payload.apollo
             * @param {number[]} payload.taskIds
             * @param {string} payload.buttonId
             */
            async [A_START_TASK](ctx, payload)
            {
                const buttonId = payload.buttonId;

                if(buttonId === undefined)
                    throw 'buttonId missing';

                const observer = payload.apollo.getClient().subscribe(
                    {
                        query: require('../graphql/live/tasks_progress.gql'),
                        variables: { ids: payload.taskIds }
                    }
                );

                const sub = observer.subscribe(
                    {
                        next({data: { tasks: { nodes }}})
                        {
                            const total = nodes.reduce((acc, val) => acc + val.progress, 0);
                            const percent = total / nodes.length;

                            ctx.commit(M_BUTTON_PROGRESS, {buttonId, percent});

                            if(percent >= 100)
                            {
                                sub.unsubscribe();
                                ctx.commit(M_BUTTON_PROGRESS, {buttonId, percent: 100}); // Make sure button resets
                            }
                        },
                        error (error)
                        {
                            ctx.commit(M_BUTTON_PROGRESS, {buttonId, percent: 100}); // Make sure button resets

                            console.error(error)
                        }
                    }
                );
            },
            /**
             * Logs the user out and reloads the page
             * @param ctx
             * @param apollo
             * @param router
             * @returns {Promise<void>}
             */
            async [A_LOGOUT](ctx, {apollo, router})
            {
                await apollo.mutate(
                    {
                        mutation: require('../graphql/mutation/logout.gql')
                    }
                );
                
                router.go(0);
            }
        },
        getters:
        {
            [G_BUTTON_PROGRESS]: state => buttonId => state.buttonProgress[buttonId],
            [G_USERNAME]: state => state.username
        }
    }
);
